<template>
  <footer class="yj-footer" :style="{ height }">
    <slot></slot>
  </footer>
</template>

<script>
  export default {
    name: 'YjFooter',

    componentName: 'YjFooter',

    props: {
      height: {
        type: String,
        default: '60px'
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/footer/src/footer.vue